import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { FamilyContext } from '../Context/FamilyHeadContext';
import {useTranslation} from "react-i18next";
import hebrewStyles from '../data/hebrewFamilyHeadStyles.json';
import englishStyles from '../data/englishFamilyHeadStyles.json';

// נגדיר את linkableWords מחוץ לקומפוננטה
const linkableWords = {
    he: [
        'וייגרסהיימר - פינקע',
        'ר\' שמואל כהן אבי הבז"ך לבונה',
        'הגאון בז"ך לבונה',
        'שבט מנסבך',
        'שבט פיסקוס',
        'ר\' וולף לרנר',
        'שבט בישיץ',
        'ר\' משה בישיץ',
        'מוהרצ"א מדינוב',
        'ר\' אברהם',
        'לעוי',
        'ר\' יוסף יונה',
        'בורשטיין',
        'ר\' משה פוגרביצקי',
        'הרב שמואל הומינר',
        'הרב ברוך יעקב זיסרמן זצ"ל',
        'הגאון הרב איסר יהודה מאלין זצ"ל',
        'שבטי פריש-שטיינהויז',
        'שבט זלדוביץ',
        'לרבנו שלמה יצחקי'
    ],
    en: [
        'Weigersheimer - Pinke',
        'R\' Shmuel Cohen, father of the Bazach Levona',
        'Gaon Bazach Levona',
        'Mensbach tribe',
        'Fiskus tribe',
        'R\' Wolf Lerner',
        'Bishitz tribe',
        'R\' Moshe Bishitz',
        'Maharza of Dinov',
        'R\' Avraham',
        'Levi',
        'R\' Yosef Yona',
        'Borstein',
        'R\' Moshe Pogrebitzky',
        'Rabbi Shmuel Hominer',
        'Rabbi Baruch Yaakov Ziserman',
        'Gaon Rabbi Isser Yehuda Malin',
        'Frisch-Steinhaus tribes',
        'Zeldovich tribe',
        'Rabbeinu Shlomo Yitzchaki'
    ]
};

const WelcomeText = () => {
    const {currentFamilyHead, pathPrefix} = useContext(FamilyContext);
    const {i18n} = useTranslation();

    // בחירת הסגנון והמילים לפי השפה
    const styles = i18n.language === 'en' ? englishStyles : hebrewStyles;
    const text = styles[currentFamilyHead.nickname]?.welcomeText;
    const wordsToLink = linkableWords[i18n.language === 'en' ? 'en' : 'he'];

    const firstDotIndex = text.indexOf('.');
    const beforeDot = text.slice(0, firstDotIndex + 1);
    const afterDot = text.slice(firstDotIndex + 1);

    const processText = (text) => {
        const parts = text.split(new RegExp(`(${wordsToLink.join('|')})`, 'g'));
        return parts.map((part, i) =>
            wordsToLink.includes(part) ? (
                <Link
                    key={i}
                    to={`${pathPrefix}person/${currentFamilyHead.gedId}`}
                    className="text-[#937c5d] hover:underline"
                >
                    {part}
                </Link>
            ) : part
        );
    };

    return (
        <div className="space-y-2">
            <p>{processText(beforeDot)}</p>
            <p>{processText(afterDot)}</p>
        </div>
    );
};

export default WelcomeText;